// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ICustomActionAlertSchema } from './CustomActionAlertSchema';

export interface ICustomActionSchema {
  /** Кастомное действие **/
  action: EAction;
  /** Алерт для подтверждения действия **/
  alert?: ICustomActionAlertSchema;
  /** Ссылка на иконку для desktop-а **/
  desktopIconUrl: string;
  /** Ссылка на иконку **/
  iconUrl: string;
  /** Длинный текст кнопки действия **/
  longText: string;
  /** Короткий текст кнопки действия **/
  shortText: string;
}
export enum EAction {
  /** Подписаться на рассылку **/
  'Subscribe' = 'subscribe',
  /** Отписаться от рассылки **/
  'Unsubscribe' = 'unsubscribe',
}
